module.exports = __webpack_public_path__ + "static/media/TeamTokens.c53f787b.png";